export const getOperationsHeaderTab = (searchParams) => {
  const tab = searchParams.get('tab');
  if (tab === 'progression') return 'progression';
  if (tab === 'tasks') return 'tasks';
  return 'dashboard';
};

export const buildOperationsHeaderTabParams = (searchParams, tab) => {
  const next = new URLSearchParams(searchParams);

  if (tab === 'progression') {
    next.set('tab', 'progression');
  } else if (tab === 'tasks') {
    next.set('tab', 'tasks');
  } else {
    next.delete('tab');
  }

  return next;
};
